module.exports = __webpack_public_path__ + "static/media/bal-place.43c5f5b6.png";